import React from 'react';
import 'date-fns';
import { TextField, Grid } from '@material-ui/core';
import { DeepMap, FieldError } from 'react-hook-form';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { IntlString } from '@utils/formatter';
import CheckboxGroup from '@components/CheckboxGroup';
import { useStylesDialogOption } from '../../styled';
import koLocale from 'date-fns/locale/ko';
import format from 'date-fns/format';
import DatePicker from './DatePicker';
import { CustomizedTypography } from '@components/Customized';

class KoLocalizedUtils extends DateFnsUtils {
  getCalendarHeaderText(date: Date) {
    return format(date, 'yyyy MM', { locale: this.locale });
  }
}
interface InputItemProps {
  name: string;
  inputProps?: any;
  errors?: DeepMap<Record<string, any>, FieldError>;
}

export const InputItem = (props: InputItemProps) => {
  const { inputRoot } = useStylesDialogOption();
  const error = props.errors && props.errors[props.name];

  const title = IntlString(`request.title.${props.name}`);
  const placeholder = IntlString(`request.placeholder.${props.name}`);
  const helperText =
    error && error.message
      ? error.message
      : IntlString(error ? `request.error.${props.name}` : '');

  return (
    <div className="input-container">
      <CustomizedTypography variant="body1">{title}</CustomizedTypography>

      <span className="input-box">
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          name={props.name}
          classes={{ root: inputRoot }}
          inputProps={props.inputProps}
          placeholder={placeholder}
          error={error ? true : false}
          helperText={error && helperText}
        />
      </span>
    </div>
  );
};

export const ProjectNameInput = (props: InputItemProps) => {
  const { inputRoot } = useStylesDialogOption();
  const error = props.errors && props.errors[props.name];

  const title = IntlString(`request.title.${props.name}`);
  const placeholder = IntlString(`request.placeholder.${props.name}`);
  const helperText =
    error && error.message
      ? error.message
      : IntlString(error ? `request.error.${props.name}` : '');

  return (
    <Grid container style={{ marginBottom: 12 }}>
      <Grid item xs={12} style={{ marginBottom: 12 }}>
        <CustomizedTypography variant="body1">{title}</CustomizedTypography>
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          name={props.name}
          classes={{ root: inputRoot }}
          inputProps={props.inputProps}
          placeholder={placeholder}
          error={error ? true : false}
          helperText={error && helperText}
        />
      </Grid>
    </Grid>
  );
};

interface DatePickerItemProps extends InputItemProps {
  value: Date;
  minDate: Date;
  onChange: (...event: any[]) => void;
  sendLog?: () => void;
}

export const MuiDatePicker = (props: DatePickerItemProps) => {
  const error = props.errors && props.errors[props.name];
  const placeholder = IntlString(`request.placeholder.${props.name}`);
  // const helperText = IntlString(error ? `request.error.${props.name}` : '');

  return (
    <MuiPickersUtilsProvider utils={KoLocalizedUtils} locale={koLocale}>
      <DatePicker {...props} placeholder={placeholder} error={error} />
    </MuiPickersUtilsProvider>
  );
};

interface CheckboxItemProps {
  xs: any;
  options: { label: string; value: string }[];
  value: string[];
  onChange: (value: string[]) => void;
  name: string;
  errors?: DeepMap<Record<string, any>, FieldError>;
}

export const CheckboxItem = (props: CheckboxItemProps) => {
  const error = props.errors && props.errors[props.name];
  const helperText = IntlString(error ? `request.error.${props.name}` : '');

  return (
    <React.Fragment>
      <CheckboxGroup {...props} gridItemProps={{ xs: props.xs }} />
      {helperText && (
        <CustomizedTypography
          color="error"
          variant="caption"
          style={{ marginTop: 12 }}
        >
          {helperText}
        </CustomizedTypography>
      )}
    </React.Fragment>
  );
};
